import {Component, ErrorHandler, Input, ChangeDetectionStrategy} from '@angular/core';
import {SearchBaseComponent} from '../../../common/search/search.component';
import {FetchService} from '../workflow-services/fetch.service';
import {FetchListData} from '../models/fetch.models';
import {LocalStorage} from '../../../common/storage/local-storage';
import {EnvisiaLocation} from '../../../common/location/envisia-location';
import {Lister} from '../../../common/wrapper.models';
import {environment} from '../../../../environments/environment';
import {DateHelper} from '../../../helper/date-helper';
import {DateRange} from '../../../core/date-range/date-range.models';

@Component({
    selector: 'fetch-list',
    templateUrl: './fetch-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FetchListComponent extends SearchBaseComponent<FetchService, FetchListData> {
  @Input() listData: Lister<FetchListData>;
  protected type = 'fetch_list';

  constructor(protected service: FetchService,
              protected errorHandler: ErrorHandler,
              protected locationService: EnvisiaLocation,
              protected storageService: LocalStorage) {
    super();
  }

  updateCreatedDateRange(date: DateRange): void {
    const query = this.query();
    query.created_date_start = DateHelper.format(date.start);
    query.created_date_end = DateHelper.format(date.end);
    query.page = 1;
    this.serviceCall(query);
  }

  get excelUri(): string {
    const uri = `${environment.apiv4uri}workflow/fetches/export`;
    const obj: { [key: string]: any } = {};
    const query = this.query();
    const keys = Object.keys(query).filter(k => k != 'sort' && k != 'order');
    keys.forEach(k => {
      obj[k] = query[k];
    });
    const params = EnvisiaLocation.httpParams(obj);
    return keys.length <= 0 ? uri : `${uri}?${params.toString()}`;
  }
}
